import { Component, ErrorInfo, ReactNode } from "react";

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Hook for centralized error monitoring (Sentry/Datadog).
    console.error("Uncaught error:", error, errorInfo);
  }

  handleReload = (): void => {
    window.location.assign("/");
  };

  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
          <h1 className="m-0 text-2xl font-semibold">Something went wrong</h1>
          <p className="m-0 max-w-md text-gray-600">
            An unexpected error occurred. Please reload the page. If the problem
            persists, contact support.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="cursor-pointer rounded-md border-none bg-secondary px-6 py-2.5 text-base text-white transition-opacity hover:opacity-90"
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
